import styled from "styled-components";

export const TaxW9AgreementContainer = styled.div`
  .file-name {
    margin-left: 14px;
    color: ${({ theme }) => theme.card.font.secondary};
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
  }

  .icon-download {
    cursor: pointer;
  }

  @media (max-width: 767px) {
    margin-top: 40px;
  }
`;

export const DocumentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 24px 0;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const DocumentIcon = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const DocumentItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const DocumentCheckbox = styled.input`
  width: 18px;
  height: 18px;
  margin-right: 8px;
  accent-color: #2563eb;
  cursor: pointer;
  border-radius: 4px;
  border: 2px solid #d1d5db;

  &:checked {
    background-color: #2563eb;
    border-color: #2563eb;
  }

  &:focus {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;

export const DocumentLabel = styled.label`
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  font-weight: 500;
  line-height: 1.4;

  &:hover {
    color: #2563eb;
  }
`;

export const AgreementSection = styled.div`
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
`;

export const AgreementCheckbox = styled.input`
  width: 18px;
  height: 18px;
  margin-top: 2px;
  accent-color: #2563eb;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 4px;
  border: 2px solid #d1d5db;

  &:checked {
    background-color: #2563eb;
    border-color: #2563eb;
  }

  &:focus {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;

export const AgreementLabel = styled.label`
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
  cursor: pointer;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
`;

export const DocumentSection = styled.div`
  margin: 8px 0;
`;

export const DocumentSectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
`;

export const DocumentSectionDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
  line-height: 1.5;
`;
